module.exports = __webpack_public_path__ + "static/img/vc.604bb3c4.svg";